var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: { id: "NewItemModal", "hide-footer": "", title: "Add Item" },
      on: {
        keyup: function($event) {
          if (
            !("button" in $event) &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          _vm.edit ? _vm.editUser() : _vm.addItem()
        }
      }
    },
    [
      _c(
        "b-form",
        [
          _c("bigCheck", { staticClass: "pt-4", attrs: { state: _vm.state } }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.state === "unloaded",
                  expression: "state==='unloaded'"
                }
              ]
            },
            [
              _c("v-field", {
                ref: "title",
                attrs: {
                  field: "title",
                  label: _vm.$t("labels.title"),
                  type: "text",
                  msg: _vm.errorMsgs,
                  val: ""
                }
              }),
              _vm._v(" "),
              _c("v-field", {
                ref: "description",
                attrs: {
                  field: "description",
                  label: _vm.$t("labels.description"),
                  type: "text",
                  msg: _vm.errorMsgs
                }
              }),
              _vm._v(" "),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.getErrors("non_field_errors") !== "",
                      expression: "getErrors('non_field_errors')!==''"
                    }
                  ],
                  staticClass: "alert alert-danger feedback-message"
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.getErrors("non_field_errors")) +
                      "\n        "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "text-right mt-2",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              this.state == "loaded"
                ? _c(
                    "b-btn",
                    {
                      attrs: {
                        variant:
                          this.state === "unloaded"
                            ? "outline-primary"
                            : "primary"
                      },
                      on: { click: _vm.clear }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("buttons.addNew")) +
                          "\n          "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.state === "unloaded"
                ? _c(
                    "b-btn",
                    {
                      attrs: { variant: "primary" },
                      on: {
                        click: function($event) {
                          _vm.edit ? _vm.editUser() : _vm.addItem()
                        }
                      }
                    },
                    [
                      _vm._v("\n            " + _vm._s(_vm.$t("buttons.save"))),
                      _c("i", { staticClass: "fa fa-save" })
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Pages/Index/NewItemModal.vue?vue&type=template&id=09c51f52&
// module id = null
// module chunks = 